<template>
  <div>
    <v-icon dark v-if="sidebarAppFull == 'sidebar'" class="bt-small-app" @click="openSidebar()">apps</v-icon>

    <v-menu v-if="sidebarAppFull == 'popover'" offset-y max-width="440">
      <template v-slot:activator="{ on }">
        <v-icon dark class="bt-small-app" v-on="on">apps</v-icon>
      </template>
      <div :class="['sidebar-apps']">
        <ul>
          <li>
            <img src="static/svg/space-shuttle.svg" />
            <span>Aeronáutico</span>
          </li>
          <li>
            <img src="static/svg/farm.svg" />
            <span>Rural</span>
          </li>
          <li>
            <img src="static/svg/wolf.svg" />
            <span>Animais/Pecuário</span>
          </li>
          <li>
            <img src="static/svg/guarantee.svg" />
            <span>Garantia</span>
          </li>
          <li>
            <img src="static/svg/social-responsibility.svg" />
            <span>Resp. Civil Geral</span>
          </li>
          <li>
            <img src="static/svg/apartment.svg" />
            <span>Residencial</span>
          </li>
          <li class="width-50">
            <img src="static/svg/tractor.svg" />
            <span>Patrimonial e Penhor Rural</span>
          </li>
          <li class="width-50">
            <img src="static/svg/submarine.svg" />
            <span>Náutico</span>
          </li>
        </ul>
      </div>
    </v-menu>

    <v-navigation-drawer
      :class="['sidebar-apps-full', sidebarAppFull == 'popover' && 'hide']"
      :style="`height: ${sidebarHeight}px`"
      v-model="sidebar"
      absolute
      right
      width="400"
      temporary
    >
      <div class="header">
        <h2>Aplicativos</h2>

        <v-btn color="primary" class="bt-sidebar-app" fab small @click="openSidebar()">
          <v-icon dark>apps</v-icon>
        </v-btn>
      </div>

      <ul>
        <li @mouseover="alterText('shuttle')">
          <div><img src="static/svg/space-shuttle.svg" /></div>
          <span>Aeronáutico</span>
        </li>
        <li @mouseover="alterText('farm')">
          <div><img src="static/svg/farm.svg" /></div>
          <span>Rural</span>
        </li>
        <li @mouseover="alterText('wolf')">
          <div><img src="static/svg/wolf.svg" /></div>
          <span>Animais/Pecuário</span>
        </li>
        <li @mouseover="alterText('guarantee')">
          <div><img src="static/svg/guarantee.svg" /></div>
          <span>Garantia</span>
        </li>
        <li @mouseover="alterText('responsibility')">
          <div><img src="static/svg/social-responsibility.svg" /></div>
          <span>Resp. Civil Geral</span>
        </li>
        <li @mouseover="alterText('apartment')">
          <div><img src="static/svg/apartment.svg" /></div>
          <span>Residencial</span>
        </li>
        <li class="width-50" @mouseover="alterText('tractor')">
          <div><img src="static/svg/tractor.svg" /></div>
          <span>Patri. e Penhor Rural</span>
        </li>
        <li class="width-50" @mouseover="alterText('submarine')">
          <div><img src="static/svg/submarine.svg" /></div>
          <span>Náutico</span>
        </li>
      </ul>

      <h2>Descrição</h2>
      <div v-if="shuttle">Aeronáutico - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>

      <div v-if="farm">Rural - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>

      <div v-if="wolf">Animais/Pecuário - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>

      <div v-if="guarantee">Garantia - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>

      <div v-if="responsibility">
        Resp. Civil Geral - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!
      </div>

      <div v-if="apartment">Residencial - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>

      <div v-if="tractor">
        Patri. e Penhor Rural - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!
      </div>

      <div v-if="submarine">Náutico - Saiba mais sobre nossas condições e modalidades disponíveis. Venha já fazer uma simulação conosco!</div>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sidebar: false,
      sidebarHeight: document.querySelector('body').clientHeight,
      shuttle: false,
      farm: false,
      wolf: false,
      guarantee: false,
      responsibility: false,
      apartment: false,
      tractor: false,
      submarine: false
    };
  },

  props: {
    sidebarAppFull: { type: String, default: 'popover' }
  },

  methods: {
    openSidebar() {
      this.sidebar = !this.sidebar;
    },

    alterText(item) {
      this.hideTextAll();
      this[item] = true;
    },

    hideTextAll() {
      this.shuttle = false;
      this.farm = false;
      this.wolf = false;
      this.guarantee = false;
      this.responsibility = false;
      this.apartment = false;
      this.tractor = false;
      this.submarine = false;
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;
}

.width-50 {
  img {
    width: 50px !important;
  }
}

.bt-small-app {
  margin-left: 20px;

  i {
    color: #fff !important;
  }
}

.bt-sidebar-app {
  box-shadow: none;
}

.v-menu__content {
  overflow: visible;
  contain: initial;
  max-width: 90%;
  border-bottom: 3px solid var(--v-primary-base);
  top: 63px !important;
}

.sidebar-apps,
.sidebar-apps-full {
  li {
    &:hover {
      img {
        transform: scale(1.2);
      }
    }

    img {
      width: 40px;
      transition: all 0.2s ease-in-out;
    }
  }
}

.sidebar-apps {
  padding: 20px 20px 0px 20px;
  background: #fff;

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      text-align: center;
      min-width: 120px;
      margin-bottom: 30px;
      cursor: pointer;

      span {
        display: flex;
        flex-direction: column;
        font-size: 15px;
      }
    }
  }

  &:before {
    position: absolute;
    right: -3px;
    top: -7px;
    content: '';
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #fff;
  }
}

.hide {
  display: none;
}

.sidebar-apps-full {
  padding: 20px;

  .header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 40px;
    align-items: center;

    h2 {
      margin: 0;
    }

    .bt-apps {
      cursor: pointer;
      .bg-icon {
        background: #cecdcd;
      }
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      min-width: 135px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;

      div {
        width: 50px;
        text-align: center;
      }

      span {
        font-size: 14px;
        margin-left: 10px;
      }
    }
  }
}

.theme--dark {
  .sidebar-apps,
  .sidebar-apps-full {
    background: #424242;

    &:before {
      border-bottom-color: #424242;
    }
  }
}

.theme--light {
  .sidebar-apps,
  .sidebar-apps-full {
    background: #fff;
  }
}
</style>
